export const userDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Full Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Last Modified",
      accessor: "updatedAt",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];